//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import followIfLoginRedirect from './components/api-authorization/followIfLoginRedirect';

export class AuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the current user's wallet setup status
     */
    getWalletStatus(): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/wallet-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWalletStatus(_response);
        });
    }

    protected processGetWalletStatus(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sets up the employee's Wallet
     * @return OK
     */
    setupWallet(request: SetupWalletRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/setup-wallet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetupWallet(_response);
        });
    }

    protected processSetupWallet(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return null;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CompaniesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get companies
     */
    getCompanies(): Promise<PagedResultOfCompanyDto> {
        let url_ = this.baseUrl + "/api/Companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompanies(_response);
        });
    }

    protected processGetCompanies(response: Response): Promise<PagedResultOfCompanyDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfCompanyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCompanyDto>(null as any);
    }

    /**
     * Get company by ID
     */
    getCompany(id: number): Promise<CompanyDto> {
        let url_ = this.baseUrl + "/api/Companies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompany(_response);
        });
    }

    protected processGetCompany(response: Response): Promise<CompanyDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDto>(null as any);
    }

    /**
     * Edit company
     */
    editCompany(id: number, command: EditCompanyCommand): Promise<EditCompanyResponse> {
        let url_ = this.baseUrl + "/api/Companies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCompany(_response);
        });
    }

    protected processEditCompany(response: Response): Promise<EditCompanyResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCompanyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCompanyResponse>(null as any);
    }

    registerCompany(command: RegisterCompanyCommand): Promise<RegisterCompanyResponse> {
        let url_ = this.baseUrl + "/api/Companies/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterCompany(_response);
        });
    }

    protected processRegisterCompany(response: Response): Promise<RegisterCompanyResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterCompanyResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterCompanyResponse>(null as any);
    }

    /**
     * Get company employees
     */
    getCompanyEmployees(companyId: number): Promise<PagedResultOfCompanyEmployeesDto> {
        let url_ = this.baseUrl + "/api/Companies/{companyId}/employees";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompanyEmployees(_response);
        });
    }

    protected processGetCompanyEmployees(response: Response): Promise<PagedResultOfCompanyEmployeesDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfCompanyEmployeesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCompanyEmployeesDto>(null as any);
    }

    /**
     * Get all employees
     */
    getEmployees(): Promise<PagedResultOfEmployeeDto> {
        let url_ = this.baseUrl + "/api/Companies/employees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: Response): Promise<PagedResultOfEmployeeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfEmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfEmployeeDto>(null as any);
    }

    registerCompanyEmployee(command: RegisterCompanyEmployeeCommand): Promise<RegisterCompanyEmployeeResponse> {
        let url_ = this.baseUrl + "/api/Companies/employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterCompanyEmployee(_response);
        });
    }

    protected processRegisterCompanyEmployee(response: Response): Promise<RegisterCompanyEmployeeResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterCompanyEmployeeResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterCompanyEmployeeResponse>(null as any);
    }

    /**
     * Get employee by ID
     */
    getEmployee(id: number): Promise<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Companies/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: Response): Promise<EmployeeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto>(null as any);
    }

    /**
     * Edit company employee
     */
    editCompanyEmployee(id: number, command: EditCompanyEmployeeCommand): Promise<EditCompanyEmployeeResponse> {
        let url_ = this.baseUrl + "/api/Companies/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCompanyEmployee(_response);
        });
    }

    protected processEditCompanyEmployee(response: Response): Promise<EditCompanyEmployeeResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCompanyEmployeeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCompanyEmployeeResponse>(null as any);
    }
}

export class DashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get dashboard statistics
     */
    getDashboardStats(): Promise<DashboardStatsDto> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDashboardStats(_response);
        });
    }

    protected processGetDashboardStats(response: Response): Promise<DashboardStatsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardStatsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardStatsDto>(null as any);
    }
}

export class DeliveriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Confirm delivery
     */
    confirmDelivery(command: ConfirmDeliveryCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Deliveries/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmDelivery(_response);
        });
    }

    protected processConfirmDelivery(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Add transport note
     */
    addTransportNote(): Promise<number> {
        let url_ = this.baseUrl + "/api/Deliveries/notes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddTransportNote(_response);
        });
    }

    protected processAddTransportNote(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get delivery confirmations
     */
    getDeliveryConfirmations(documentUUID: string): Promise<DeliveryConfirmationDto[]> {
        let url_ = this.baseUrl + "/api/Deliveries/document/{documentUUID}";
        if (documentUUID === undefined || documentUUID === null)
            throw new Error("The parameter 'documentUUID' must be defined.");
        url_ = url_.replace("{documentUUID}", encodeURIComponent("" + documentUUID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeliveryConfirmations(_response);
        });
    }

    protected processGetDeliveryConfirmations(response: Response): Promise<DeliveryConfirmationDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryConfirmationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryConfirmationDto[]>(null as any);
    }

    /**
     * Get transport notes
     */
    getTransportNotes(documentUUID: string): Promise<PagedResultOfTransportNotesDto> {
        let url_ = this.baseUrl + "/api/Deliveries/notes/document/{documentUUID}";
        if (documentUUID === undefined || documentUUID === null)
            throw new Error("The parameter 'documentUUID' must be defined.");
        url_ = url_.replace("{documentUUID}", encodeURIComponent("" + documentUUID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransportNotes(_response);
        });
    }

    protected processGetTransportNotes(response: Response): Promise<PagedResultOfTransportNotesDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfTransportNotesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfTransportNotesDto>(null as any);
    }

    /**
     * Get transport note details
     */
    getTransportNote(noteId: number): Promise<TransportNoteDetailDto> {
        let url_ = this.baseUrl + "/api/Deliveries/notes/{noteId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransportNote(_response);
        });
    }

    protected processGetTransportNote(response: Response): Promise<TransportNoteDetailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportNoteDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportNoteDetailDto>(null as any);
    }
}

export class DocumentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Upload a new eCMR document
     * @return OK
     */
    uploadDocument(iFormFile: Blob): Promise<void> {
        let url_ = this.baseUrl + "/api/Documents/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = iFormFile;

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return null;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UploadDocumentResponse.fromJS(resultData201);
            return throwException("A server side error occurred.", status, _responseText, _headers, result201);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update an existing document
     */
    updateDocument(uuid: string, iFormFile: Blob): Promise<UpdateDocumentResponse> {
        let url_ = this.baseUrl + "/api/Documents/{uuid}/update";
        if (uuid === undefined || uuid === null)
            throw new Error("The parameter 'uuid' must be defined.");
        url_ = url_.replace("{uuid}", encodeURIComponent("" + uuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = iFormFile;

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDocument(_response);
        });
    }

    protected processUpdateDocument(response: Response): Promise<UpdateDocumentResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateDocumentResponse>(null as any);
    }

    /**
     * Sign a document
     */
    signDocument(documentUUID: string, command: SignDocumentCommand): Promise<SignDocumentResponse> {
        let url_ = this.baseUrl + "/api/Documents/{documentUUID}/sign";
        if (documentUUID === undefined || documentUUID === null)
            throw new Error("The parameter 'documentUUID' must be defined.");
        url_ = url_.replace("{documentUUID}", encodeURIComponent("" + documentUUID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignDocument(_response);
        });
    }

    protected processSignDocument(response: Response): Promise<SignDocumentResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignDocumentResponse>(null as any);
    }

    /**
     * Get document details
     */
    getDocument(documentUUID: string): Promise<DocumentDetailDto> {
        let url_ = this.baseUrl + "/api/Documents/{documentUUID}";
        if (documentUUID === undefined || documentUUID === null)
            throw new Error("The parameter 'documentUUID' must be defined.");
        url_ = url_.replace("{documentUUID}", encodeURIComponent("" + documentUUID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: Response): Promise<DocumentDetailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailDto>(null as any);
    }

    /**
     * Get documents
     * @param searchKeyword (optional) 
     */
    getDocuments(searchKeyword: string | null | undefined): Promise<PagedResultOfDocumentDto> {
        let url_ = this.baseUrl + "/api/Documents?";
        if (searchKeyword !== undefined && searchKeyword !== null)
            url_ += "searchKeyword=" + encodeURIComponent("" + searchKeyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: Response): Promise<PagedResultOfDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfDocumentDto>(null as any);
    }

    /**
     * Retrieve full eCMR
     */
    retrieveDocument(documentUUID: string): Promise<RetrieveDocumentResponse> {
        let url_ = this.baseUrl + "/api/Documents/{documentUUID}/retrieve";
        if (documentUUID === undefined || documentUUID === null)
            throw new Error("The parameter 'documentUUID' must be defined.");
        url_ = url_.replace("{documentUUID}", encodeURIComponent("" + documentUUID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRetrieveDocument(_response);
        });
    }

    protected processRetrieveDocument(response: Response): Promise<RetrieveDocumentResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrieveDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveDocumentResponse>(null as any);
    }

    /**
     * Get document view URL
     */
    viewDocument(documentUUID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Documents/{documentUUID}/view";
        if (documentUUID === undefined || documentUUID === null)
            throw new Error("The parameter 'documentUUID' must be defined.");
        url_ = url_.replace("{documentUUID}", encodeURIComponent("" + documentUUID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processViewDocument(_response);
        });
    }

    protected processViewDocument(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Show document HTML
     */
    showDocument(documentUUID: string): Promise<ShowDocumentResponse> {
        let url_ = this.baseUrl + "/api/Documents/{documentUUID}/show";
        if (documentUUID === undefined || documentUUID === null)
            throw new Error("The parameter 'documentUUID' must be defined.");
        url_ = url_.replace("{documentUUID}", encodeURIComponent("" + documentUUID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShowDocument(_response);
        });
    }

    protected processShowDocument(response: Response): Promise<ShowDocumentResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShowDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShowDocumentResponse>(null as any);
    }
}

export class RequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Sign and submit blockchain request
     */
    signAndSubmitBlockchainRequest(command: SignAndSubmitBlockchainRequestCommand): Promise<SignAndSubmitBlockchainRequestResponse> {
        let url_ = this.baseUrl + "/api/Requests/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignAndSubmitBlockchainRequest(_response);
        });
    }

    protected processSignAndSubmitBlockchainRequest(response: Response): Promise<SignAndSubmitBlockchainRequestResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignAndSubmitBlockchainRequestResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignAndSubmitBlockchainRequestResponse>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Me
     */
    me(): Promise<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/api/Users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: Response): Promise<{ [key: string]: string[]; }> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string[]; }>(null as any);
    }
}

export class WalletClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get current wallet session status
     */
    getSession(): Promise<WalletSessionDto> {
        let url_ = this.baseUrl + "/api/Wallet/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSession(_response);
        });
    }

    protected processGetSession(response: Response): Promise<WalletSessionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletSessionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletSessionDto>(null as any);
    }

    /**
     * Unlock wallet for blockchain operations
     */
    unlock(request: UnlockWalletRequest): Promise<UnlockWalletResponse> {
        let url_ = this.baseUrl + "/api/Wallet/unlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnlock(_response);
        });
    }

    protected processUnlock(response: Response): Promise<UnlockWalletResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnlockWalletResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnlockWalletResponse>(null as any);
    }

    /**
     * Lock wallet and end session
     */
    lock(): Promise<LockWalletResponse> {
        let url_ = this.baseUrl + "/api/Wallet/lock";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLock(_response);
        });
    }

    protected processLock(response: Response): Promise<LockWalletResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LockWalletResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LockWalletResponse>(null as any);
    }
}

export class SetupWalletRequest implements ISetupWalletRequest {
    walletPassword?: string;

    constructor(data?: ISetupWalletRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walletPassword = _data["walletPassword"];
        }
    }

    static fromJS(data: any): SetupWalletRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetupWalletRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletPassword"] = this.walletPassword;
        return data;
    }
}

export interface ISetupWalletRequest {
    walletPassword?: string;
}

export class PagedResultOfCompanyDto implements IPagedResultOfCompanyDto {
    items?: CompanyDto[];
    metadata?: PaginationMetadata;

    constructor(data?: IPagedResultOfCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompanyDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? PaginationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedResultOfCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedResultOfCompanyDto {
    items?: CompanyDto[];
    metadata?: PaginationMetadata;
}

export class CompanyDto implements ICompanyDto {
    id?: number;
    vatNumber?: string;
    companyName?: string;
    nexusCompanyUUID?: string | undefined;
    contactEmail?: string;
    contactPhone?: string | undefined;
    restrictionLevel?: number;
    isActive?: boolean;
    employeeCount?: number;
    documentCount?: number;
    created?: Date;
    companyEmployeeAdminId?: number | undefined;
    webhookEnabled?: boolean;
    webhookUrl?: string | undefined;
    webhookSigningKey?: string | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vatNumber = _data["vatNumber"];
            this.companyName = _data["companyName"];
            this.nexusCompanyUUID = _data["nexusCompanyUUID"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.restrictionLevel = _data["restrictionLevel"];
            this.isActive = _data["isActive"];
            this.employeeCount = _data["employeeCount"];
            this.documentCount = _data["documentCount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.companyEmployeeAdminId = _data["companyEmployeeAdminId"];
            this.webhookEnabled = _data["webhookEnabled"];
            this.webhookUrl = _data["webhookUrl"];
            this.webhookSigningKey = _data["webhookSigningKey"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vatNumber"] = this.vatNumber;
        data["companyName"] = this.companyName;
        data["nexusCompanyUUID"] = this.nexusCompanyUUID;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["restrictionLevel"] = this.restrictionLevel;
        data["isActive"] = this.isActive;
        data["employeeCount"] = this.employeeCount;
        data["documentCount"] = this.documentCount;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["companyEmployeeAdminId"] = this.companyEmployeeAdminId;
        data["webhookEnabled"] = this.webhookEnabled;
        data["webhookUrl"] = this.webhookUrl;
        data["webhookSigningKey"] = this.webhookSigningKey;
        return data;
    }
}

export interface ICompanyDto {
    id?: number;
    vatNumber?: string;
    companyName?: string;
    nexusCompanyUUID?: string | undefined;
    contactEmail?: string;
    contactPhone?: string | undefined;
    restrictionLevel?: number;
    isActive?: boolean;
    employeeCount?: number;
    documentCount?: number;
    created?: Date;
    companyEmployeeAdminId?: number | undefined;
    webhookEnabled?: boolean;
    webhookUrl?: string | undefined;
    webhookSigningKey?: string | undefined;
}

export class PaginationMetadata implements IPaginationMetadata {
    currentPage?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    hasNext?: boolean;
    hasPrevious?: boolean;

    constructor(data?: IPaginationMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasNext = _data["hasNext"];
            this.hasPrevious = _data["hasPrevious"];
        }
    }

    static fromJS(data: any): PaginationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasNext"] = this.hasNext;
        data["hasPrevious"] = this.hasPrevious;
        return data;
    }
}

export interface IPaginationMetadata {
    currentPage?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    hasNext?: boolean;
    hasPrevious?: boolean;
}

export class RegisterCompanyResponse implements IRegisterCompanyResponse {
    requestUUID?: string;
    companyId?: number;

    constructor(data?: IRegisterCompanyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestUUID = _data["requestUUID"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): RegisterCompanyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCompanyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUUID"] = this.requestUUID;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IRegisterCompanyResponse {
    requestUUID?: string;
    companyId?: number;
}

export class RegisterCompanyCommand implements IRegisterCompanyCommand {
    vatNumber?: string;
    companyName?: string;
    address?: string;
    contactEmail?: string;
    contactPhone?: string | undefined;
    companyEmployeeAdminId?: number;

    constructor(data?: IRegisterCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vatNumber = _data["vatNumber"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.companyEmployeeAdminId = _data["companyEmployeeAdminId"];
        }
    }

    static fromJS(data: any): RegisterCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vatNumber"] = this.vatNumber;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["companyEmployeeAdminId"] = this.companyEmployeeAdminId;
        return data;
    }
}

export interface IRegisterCompanyCommand {
    vatNumber?: string;
    companyName?: string;
    address?: string;
    contactEmail?: string;
    contactPhone?: string | undefined;
    companyEmployeeAdminId?: number;
}

export class EditCompanyResponse implements IEditCompanyResponse {
    companyId?: number;
    requestsUUID?: string[];

    constructor(data?: IEditCompanyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["requestsUUID"])) {
                this.requestsUUID = [] as any;
                for (let item of _data["requestsUUID"])
                    this.requestsUUID!.push(item);
            }
        }
    }

    static fromJS(data: any): EditCompanyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.requestsUUID)) {
            data["requestsUUID"] = [];
            for (let item of this.requestsUUID)
                data["requestsUUID"].push(item);
        }
        return data;
    }
}

export interface IEditCompanyResponse {
    companyId?: number;
    requestsUUID?: string[];
}

export class EditCompanyCommand implements IEditCompanyCommand {
    companyId?: number;
    addedEmployeeIds?: number[];
    webhookEnabled?: boolean | undefined;
    webhookUrl?: string | undefined;
    webhookSigningKey?: string | undefined;
    restrictionLevel?: number | undefined;

    constructor(data?: IEditCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["addedEmployeeIds"])) {
                this.addedEmployeeIds = [] as any;
                for (let item of _data["addedEmployeeIds"])
                    this.addedEmployeeIds!.push(item);
            }
            this.webhookEnabled = _data["webhookEnabled"];
            this.webhookUrl = _data["webhookUrl"];
            this.webhookSigningKey = _data["webhookSigningKey"];
            this.restrictionLevel = _data["restrictionLevel"];
        }
    }

    static fromJS(data: any): EditCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.addedEmployeeIds)) {
            data["addedEmployeeIds"] = [];
            for (let item of this.addedEmployeeIds)
                data["addedEmployeeIds"].push(item);
        }
        data["webhookEnabled"] = this.webhookEnabled;
        data["webhookUrl"] = this.webhookUrl;
        data["webhookSigningKey"] = this.webhookSigningKey;
        data["restrictionLevel"] = this.restrictionLevel;
        return data;
    }
}

export interface IEditCompanyCommand {
    companyId?: number;
    addedEmployeeIds?: number[];
    webhookEnabled?: boolean | undefined;
    webhookUrl?: string | undefined;
    webhookSigningKey?: string | undefined;
    restrictionLevel?: number | undefined;
}

export class PagedResultOfCompanyEmployeesDto implements IPagedResultOfCompanyEmployeesDto {
    items?: CompanyEmployeesDto[];
    metadata?: PaginationMetadata;

    constructor(data?: IPagedResultOfCompanyEmployeesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompanyEmployeesDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? PaginationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedResultOfCompanyEmployeesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCompanyEmployeesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedResultOfCompanyEmployeesDto {
    items?: CompanyEmployeesDto[];
    metadata?: PaginationMetadata;
}

export class CompanyEmployeesDto implements ICompanyEmployeesDto {
    companyId?: number | undefined;
    walletAddress?: string;
    nexusEmployeeUUID?: string;
    fullName?: string;
    email?: string;
    phoneNumber?: string | undefined;
    role?: string | undefined;
    restrictionLevel?: number;
    isActive?: boolean;

    constructor(data?: ICompanyEmployeesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.walletAddress = _data["walletAddress"];
            this.nexusEmployeeUUID = _data["nexusEmployeeUUID"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.role = _data["role"];
            this.restrictionLevel = _data["restrictionLevel"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CompanyEmployeesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyEmployeesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["walletAddress"] = this.walletAddress;
        data["nexusEmployeeUUID"] = this.nexusEmployeeUUID;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["role"] = this.role;
        data["restrictionLevel"] = this.restrictionLevel;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICompanyEmployeesDto {
    companyId?: number | undefined;
    walletAddress?: string;
    nexusEmployeeUUID?: string;
    fullName?: string;
    email?: string;
    phoneNumber?: string | undefined;
    role?: string | undefined;
    restrictionLevel?: number;
    isActive?: boolean;
}

export class PagedResultOfEmployeeDto implements IPagedResultOfEmployeeDto {
    items?: EmployeeDto[];
    metadata?: PaginationMetadata;

    constructor(data?: IPagedResultOfEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmployeeDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? PaginationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedResultOfEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedResultOfEmployeeDto {
    items?: EmployeeDto[];
    metadata?: PaginationMetadata;
}

export class EmployeeDto implements IEmployeeDto {
    id?: number;
    companyId?: number | undefined;
    companyName?: string | undefined;
    walletAddress?: string;
    nexusEmployeeUUID?: string;
    fullName?: string;
    email?: string;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    createdAt?: Date | undefined;
    role?: string;
    restrictionLevel?: number;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.walletAddress = _data["walletAddress"];
            this.nexusEmployeeUUID = _data["nexusEmployeeUUID"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.role = _data["role"];
            this.restrictionLevel = _data["restrictionLevel"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["walletAddress"] = this.walletAddress;
        data["nexusEmployeeUUID"] = this.nexusEmployeeUUID;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["role"] = this.role;
        data["restrictionLevel"] = this.restrictionLevel;
        return data;
    }
}

export interface IEmployeeDto {
    id?: number;
    companyId?: number | undefined;
    companyName?: string | undefined;
    walletAddress?: string;
    nexusEmployeeUUID?: string;
    fullName?: string;
    email?: string;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    createdAt?: Date | undefined;
    role?: string;
    restrictionLevel?: number;
}

export class RegisterCompanyEmployeeResponse implements IRegisterCompanyEmployeeResponse {
    employeeId?: string;

    constructor(data?: IRegisterCompanyEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): RegisterCompanyEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCompanyEmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IRegisterCompanyEmployeeResponse {
    employeeId?: string;
}

export class RegisterCompanyEmployeeCommand implements IRegisterCompanyEmployeeCommand {
    fullName?: string;
    email?: string;
    username?: string;
    phoneNumber?: string | undefined;
    restrictionLevel?: number;
    role?: string;

    constructor(data?: IRegisterCompanyEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.phoneNumber = _data["phoneNumber"];
            this.restrictionLevel = _data["restrictionLevel"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): RegisterCompanyEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCompanyEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["username"] = this.username;
        data["phoneNumber"] = this.phoneNumber;
        data["restrictionLevel"] = this.restrictionLevel;
        data["role"] = this.role;
        return data;
    }
}

export interface IRegisterCompanyEmployeeCommand {
    fullName?: string;
    email?: string;
    username?: string;
    phoneNumber?: string | undefined;
    restrictionLevel?: number;
    role?: string;
}

export class EditCompanyEmployeeResponse implements IEditCompanyEmployeeResponse {
    requestUUID?: string;
    employeeId?: string | undefined;

    constructor(data?: IEditCompanyEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestUUID = _data["requestUUID"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EditCompanyEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanyEmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUUID"] = this.requestUUID;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEditCompanyEmployeeResponse {
    requestUUID?: string;
    employeeId?: string | undefined;
}

export class EditCompanyEmployeeCommand implements IEditCompanyEmployeeCommand {
    employeeId?: string;
    fullName?: string;
    phoneNumber?: string | undefined;
    restrictionLevel?: number;

    constructor(data?: IEditCompanyEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.restrictionLevel = _data["restrictionLevel"];
        }
    }

    static fromJS(data: any): EditCompanyEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanyEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["restrictionLevel"] = this.restrictionLevel;
        return data;
    }
}

export interface IEditCompanyEmployeeCommand {
    employeeId?: string;
    fullName?: string;
    phoneNumber?: string | undefined;
    restrictionLevel?: number;
}

export class DashboardStatsDto implements IDashboardStatsDto {
    totalDocuments?: number;
    inTransitDocuments?: number;
    signedDocuments?: number;
    deliveredDocuments?: number;
    pendingDocuments?: number;
    totalCompanies?: number;
    totalEmployees?: number;
    previousTotalDocuments?: number;
    previousInTransitDocuments?: number;
    previousSignedDocuments?: number;
    previousDeliveredDocuments?: number;
    previousPendingDocuments?: number;
    previousTotalCompanies?: number;
    previousTotalEmployees?: number;
    ecmrsByMonth?: EcmrByMonthDto[];
    ecmrsByStatus?: EcmrByStatusDto[];
    recentDocuments?: RecentDocumentDto[];

    constructor(data?: IDashboardStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDocuments = _data["totalDocuments"];
            this.inTransitDocuments = _data["inTransitDocuments"];
            this.signedDocuments = _data["signedDocuments"];
            this.deliveredDocuments = _data["deliveredDocuments"];
            this.pendingDocuments = _data["pendingDocuments"];
            this.totalCompanies = _data["totalCompanies"];
            this.totalEmployees = _data["totalEmployees"];
            this.previousTotalDocuments = _data["previousTotalDocuments"];
            this.previousInTransitDocuments = _data["previousInTransitDocuments"];
            this.previousSignedDocuments = _data["previousSignedDocuments"];
            this.previousDeliveredDocuments = _data["previousDeliveredDocuments"];
            this.previousPendingDocuments = _data["previousPendingDocuments"];
            this.previousTotalCompanies = _data["previousTotalCompanies"];
            this.previousTotalEmployees = _data["previousTotalEmployees"];
            if (Array.isArray(_data["ecmrsByMonth"])) {
                this.ecmrsByMonth = [] as any;
                for (let item of _data["ecmrsByMonth"])
                    this.ecmrsByMonth!.push(EcmrByMonthDto.fromJS(item));
            }
            if (Array.isArray(_data["ecmrsByStatus"])) {
                this.ecmrsByStatus = [] as any;
                for (let item of _data["ecmrsByStatus"])
                    this.ecmrsByStatus!.push(EcmrByStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["recentDocuments"])) {
                this.recentDocuments = [] as any;
                for (let item of _data["recentDocuments"])
                    this.recentDocuments!.push(RecentDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDocuments"] = this.totalDocuments;
        data["inTransitDocuments"] = this.inTransitDocuments;
        data["signedDocuments"] = this.signedDocuments;
        data["deliveredDocuments"] = this.deliveredDocuments;
        data["pendingDocuments"] = this.pendingDocuments;
        data["totalCompanies"] = this.totalCompanies;
        data["totalEmployees"] = this.totalEmployees;
        data["previousTotalDocuments"] = this.previousTotalDocuments;
        data["previousInTransitDocuments"] = this.previousInTransitDocuments;
        data["previousSignedDocuments"] = this.previousSignedDocuments;
        data["previousDeliveredDocuments"] = this.previousDeliveredDocuments;
        data["previousPendingDocuments"] = this.previousPendingDocuments;
        data["previousTotalCompanies"] = this.previousTotalCompanies;
        data["previousTotalEmployees"] = this.previousTotalEmployees;
        if (Array.isArray(this.ecmrsByMonth)) {
            data["ecmrsByMonth"] = [];
            for (let item of this.ecmrsByMonth)
                data["ecmrsByMonth"].push(item.toJSON());
        }
        if (Array.isArray(this.ecmrsByStatus)) {
            data["ecmrsByStatus"] = [];
            for (let item of this.ecmrsByStatus)
                data["ecmrsByStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.recentDocuments)) {
            data["recentDocuments"] = [];
            for (let item of this.recentDocuments)
                data["recentDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardStatsDto {
    totalDocuments?: number;
    inTransitDocuments?: number;
    signedDocuments?: number;
    deliveredDocuments?: number;
    pendingDocuments?: number;
    totalCompanies?: number;
    totalEmployees?: number;
    previousTotalDocuments?: number;
    previousInTransitDocuments?: number;
    previousSignedDocuments?: number;
    previousDeliveredDocuments?: number;
    previousPendingDocuments?: number;
    previousTotalCompanies?: number;
    previousTotalEmployees?: number;
    ecmrsByMonth?: EcmrByMonthDto[];
    ecmrsByStatus?: EcmrByStatusDto[];
    recentDocuments?: RecentDocumentDto[];
}

export class EcmrByMonthDto implements IEcmrByMonthDto {
    month?: string;
    count?: number;

    constructor(data?: IEcmrByMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): EcmrByMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new EcmrByMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["count"] = this.count;
        return data;
    }
}

export interface IEcmrByMonthDto {
    month?: string;
    count?: number;
}

export class EcmrByStatusDto implements IEcmrByStatusDto {
    status?: string;
    count?: number;

    constructor(data?: IEcmrByStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): EcmrByStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new EcmrByStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IEcmrByStatusDto {
    status?: string;
    count?: number;
}

export class RecentDocumentDto implements IRecentDocumentDto {
    id?: string;
    documentUUID?: string;
    documentNumber?: string;
    companyName?: string;
    originAddress?: string;
    destinationAddress?: string;
    status?: DocumentStatus;
    created?: Date;

    constructor(data?: IRecentDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentUUID = _data["documentUUID"];
            this.documentNumber = _data["documentNumber"];
            this.companyName = _data["companyName"];
            this.originAddress = _data["originAddress"];
            this.destinationAddress = _data["destinationAddress"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecentDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentUUID"] = this.documentUUID;
        data["documentNumber"] = this.documentNumber;
        data["companyName"] = this.companyName;
        data["originAddress"] = this.originAddress;
        data["destinationAddress"] = this.destinationAddress;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecentDocumentDto {
    id?: string;
    documentUUID?: string;
    documentNumber?: string;
    companyName?: string;
    originAddress?: string;
    destinationAddress?: string;
    status?: DocumentStatus;
    created?: Date;
}

export enum DocumentStatus {
    Draft = 0,
    Pending = 1,
    InTransit = 2,
    Delivered = 3,
    Signed = 4,
    Cancelled = 5,
}

export class ConfirmDeliveryCommand implements IConfirmDeliveryCommand {
    documentId?: number;
    signedByEmployeeId?: number | undefined;
    signedByName?: string;
    deliveryDate?: Date;
    deliveryLocation?: string;
    signatureImagePath?: string | undefined;
    hasReservations?: boolean;
    deliveryNotes?: string | undefined;
    geoLocation?: string | undefined;
    deviceInfo?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IConfirmDeliveryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.signedByEmployeeId = _data["signedByEmployeeId"];
            this.signedByName = _data["signedByName"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deliveryLocation = _data["deliveryLocation"];
            this.signatureImagePath = _data["signatureImagePath"];
            this.hasReservations = _data["hasReservations"];
            this.deliveryNotes = _data["deliveryNotes"];
            this.geoLocation = _data["geoLocation"];
            this.deviceInfo = _data["deviceInfo"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): ConfirmDeliveryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDeliveryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["signedByEmployeeId"] = this.signedByEmployeeId;
        data["signedByName"] = this.signedByName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deliveryLocation"] = this.deliveryLocation;
        data["signatureImagePath"] = this.signatureImagePath;
        data["hasReservations"] = this.hasReservations;
        data["deliveryNotes"] = this.deliveryNotes;
        data["geoLocation"] = this.geoLocation;
        data["deviceInfo"] = this.deviceInfo;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IConfirmDeliveryCommand {
    documentId?: number;
    signedByEmployeeId?: number | undefined;
    signedByName?: string;
    deliveryDate?: Date;
    deliveryLocation?: string;
    signatureImagePath?: string | undefined;
    hasReservations?: boolean;
    deliveryNotes?: string | undefined;
    geoLocation?: string | undefined;
    deviceInfo?: string | undefined;
    ipAddress?: string | undefined;
}

export class DeliveryConfirmationDto implements IDeliveryConfirmationDto {
    id?: number;
    signedByName?: string;
    employeeName?: string | undefined;
    deliveryDate?: Date;
    deliveryLocation?: string;
    hasReservations?: boolean;
    deliveryNotes?: string | undefined;
    noteCount?: number;
    created?: Date;

    constructor(data?: IDeliveryConfirmationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signedByName = _data["signedByName"];
            this.employeeName = _data["employeeName"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deliveryLocation = _data["deliveryLocation"];
            this.hasReservations = _data["hasReservations"];
            this.deliveryNotes = _data["deliveryNotes"];
            this.noteCount = _data["noteCount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeliveryConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signedByName"] = this.signedByName;
        data["employeeName"] = this.employeeName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deliveryLocation"] = this.deliveryLocation;
        data["hasReservations"] = this.hasReservations;
        data["deliveryNotes"] = this.deliveryNotes;
        data["noteCount"] = this.noteCount;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeliveryConfirmationDto {
    id?: number;
    signedByName?: string;
    employeeName?: string | undefined;
    deliveryDate?: Date;
    deliveryLocation?: string;
    hasReservations?: boolean;
    deliveryNotes?: string | undefined;
    noteCount?: number;
    created?: Date;
}

export class PagedResultOfTransportNotesDto implements IPagedResultOfTransportNotesDto {
    items?: TransportNotesDto[];
    metadata?: PaginationMetadata;

    constructor(data?: IPagedResultOfTransportNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TransportNotesDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? PaginationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedResultOfTransportNotesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfTransportNotesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedResultOfTransportNotesDto {
    items?: TransportNotesDto[];
    metadata?: PaginationMetadata;
}

export class TransportNotesDto implements ITransportNotesDto {
    documentId?: number;
    deliveryConfirmationId?: number | undefined;
    noteType?: NoteType;
    description?: string;
    reportedBy?: string;
    reportedAt?: Date;
    severity?: NoteSeverity;
    location?: string | undefined;
    imagePath?: string | undefined;
    isResolved?: boolean;
    resolution?: string | undefined;
    resolvedAt?: Date | undefined;

    constructor(data?: ITransportNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.deliveryConfirmationId = _data["deliveryConfirmationId"];
            this.noteType = _data["noteType"];
            this.description = _data["description"];
            this.reportedBy = _data["reportedBy"];
            this.reportedAt = _data["reportedAt"] ? new Date(_data["reportedAt"].toString()) : <any>undefined;
            this.severity = _data["severity"];
            this.location = _data["location"];
            this.imagePath = _data["imagePath"];
            this.isResolved = _data["isResolved"];
            this.resolution = _data["resolution"];
            this.resolvedAt = _data["resolvedAt"] ? new Date(_data["resolvedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransportNotesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportNotesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["deliveryConfirmationId"] = this.deliveryConfirmationId;
        data["noteType"] = this.noteType;
        data["description"] = this.description;
        data["reportedBy"] = this.reportedBy;
        data["reportedAt"] = this.reportedAt ? this.reportedAt.toISOString() : <any>undefined;
        data["severity"] = this.severity;
        data["location"] = this.location;
        data["imagePath"] = this.imagePath;
        data["isResolved"] = this.isResolved;
        data["resolution"] = this.resolution;
        data["resolvedAt"] = this.resolvedAt ? this.resolvedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITransportNotesDto {
    documentId?: number;
    deliveryConfirmationId?: number | undefined;
    noteType?: NoteType;
    description?: string;
    reportedBy?: string;
    reportedAt?: Date;
    severity?: NoteSeverity;
    location?: string | undefined;
    imagePath?: string | undefined;
    isResolved?: boolean;
    resolution?: string | undefined;
    resolvedAt?: Date | undefined;
}

export enum NoteType {
    Reservation = 0,
    Observation = 1,
    Damage = 2,
    Delay = 3,
    Other = 4,
}

export enum NoteSeverity {
    Low = 0,
    Medium = 1,
    High = 2,
    Critical = 3,
}

export class TransportNoteDetailDto implements ITransportNoteDetailDto {
    id?: number;
    documentId?: number;
    documentNumber?: string;
    documentUUID?: string;
    deliveryConfirmationId?: number | undefined;
    noteType?: NoteType;
    description?: string;
    reportedBy?: string;
    reportedAt?: Date;
    severity?: NoteSeverity;
    location?: string | undefined;
    imagePath?: string | undefined;
    isResolved?: boolean;
    resolution?: string | undefined;
    resolvedAt?: Date | undefined;

    constructor(data?: ITransportNoteDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.documentNumber = _data["documentNumber"];
            this.documentUUID = _data["documentUUID"];
            this.deliveryConfirmationId = _data["deliveryConfirmationId"];
            this.noteType = _data["noteType"];
            this.description = _data["description"];
            this.reportedBy = _data["reportedBy"];
            this.reportedAt = _data["reportedAt"] ? new Date(_data["reportedAt"].toString()) : <any>undefined;
            this.severity = _data["severity"];
            this.location = _data["location"];
            this.imagePath = _data["imagePath"];
            this.isResolved = _data["isResolved"];
            this.resolution = _data["resolution"];
            this.resolvedAt = _data["resolvedAt"] ? new Date(_data["resolvedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransportNoteDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportNoteDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["documentNumber"] = this.documentNumber;
        data["documentUUID"] = this.documentUUID;
        data["deliveryConfirmationId"] = this.deliveryConfirmationId;
        data["noteType"] = this.noteType;
        data["description"] = this.description;
        data["reportedBy"] = this.reportedBy;
        data["reportedAt"] = this.reportedAt ? this.reportedAt.toISOString() : <any>undefined;
        data["severity"] = this.severity;
        data["location"] = this.location;
        data["imagePath"] = this.imagePath;
        data["isResolved"] = this.isResolved;
        data["resolution"] = this.resolution;
        data["resolvedAt"] = this.resolvedAt ? this.resolvedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITransportNoteDetailDto {
    id?: number;
    documentId?: number;
    documentNumber?: string;
    documentUUID?: string;
    deliveryConfirmationId?: number | undefined;
    noteType?: NoteType;
    description?: string;
    reportedBy?: string;
    reportedAt?: Date;
    severity?: NoteSeverity;
    location?: string | undefined;
    imagePath?: string | undefined;
    isResolved?: boolean;
    resolution?: string | undefined;
    resolvedAt?: Date | undefined;
}

export class UploadDocumentResponse implements IUploadDocumentResponse {
    documentId?: number;
    documentUUID?: string | undefined;
    requestUUID?: string | undefined;

    constructor(data?: IUploadDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentUUID = _data["documentUUID"];
            this.requestUUID = _data["requestUUID"];
        }
    }

    static fromJS(data: any): UploadDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentUUID"] = this.documentUUID;
        data["requestUUID"] = this.requestUUID;
        return data;
    }
}

export interface IUploadDocumentResponse {
    documentId?: number;
    documentUUID?: string | undefined;
    requestUUID?: string | undefined;
}

export class UpdateDocumentResponse implements IUpdateDocumentResponse {
    documentId?: number;
    documentUUID?: string;
    requestUUID?: string;
    version?: number;

    constructor(data?: IUpdateDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentUUID = _data["documentUUID"];
            this.requestUUID = _data["requestUUID"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): UpdateDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentUUID"] = this.documentUUID;
        data["requestUUID"] = this.requestUUID;
        data["version"] = this.version;
        return data;
    }
}

export interface IUpdateDocumentResponse {
    documentId?: number;
    documentUUID?: string;
    requestUUID?: string;
    version?: number;
}

export class SignDocumentResponse implements ISignDocumentResponse {
    documentId?: number;
    documentUUID?: string | undefined;
    requestUUID?: string | undefined;
    signatureId?: number;
    deliveryConfirmationId?: number;
    message?: string | undefined;

    constructor(data?: ISignDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentUUID = _data["documentUUID"];
            this.requestUUID = _data["requestUUID"];
            this.signatureId = _data["signatureId"];
            this.deliveryConfirmationId = _data["deliveryConfirmationId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SignDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentUUID"] = this.documentUUID;
        data["requestUUID"] = this.requestUUID;
        data["signatureId"] = this.signatureId;
        data["deliveryConfirmationId"] = this.deliveryConfirmationId;
        data["message"] = this.message;
        return data;
    }
}

export interface ISignDocumentResponse {
    documentId?: number;
    documentUUID?: string | undefined;
    requestUUID?: string | undefined;
    signatureId?: number;
    deliveryConfirmationId?: number;
    message?: string | undefined;
}

export class SignDocumentCommand implements ISignDocumentCommand {
    documentUUID?: string;
    signature?: string;
    acceptingParty?: string;
    role?: SignatureRole;
    signedByName?: string;
    signatureLocation?: string;
    notes?: string | undefined;

    constructor(data?: ISignDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentUUID = _data["documentUUID"];
            this.signature = _data["signature"];
            this.acceptingParty = _data["acceptingParty"];
            this.role = _data["role"];
            this.signedByName = _data["signedByName"];
            this.signatureLocation = _data["signatureLocation"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): SignDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentUUID"] = this.documentUUID;
        data["signature"] = this.signature;
        data["acceptingParty"] = this.acceptingParty;
        data["role"] = this.role;
        data["signedByName"] = this.signedByName;
        data["signatureLocation"] = this.signatureLocation;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ISignDocumentCommand {
    documentUUID?: string;
    signature?: string;
    acceptingParty?: string;
    role?: SignatureRole;
    signedByName?: string;
    signatureLocation?: string;
    notes?: string | undefined;
}

export enum SignatureRole {
    Sender = 0,
    Carrier = 1,
    Consignee = 2,
}

export class DocumentDetailDto implements IDocumentDetailDto {
    id?: number;
    documentUUID?: string | undefined;
    documentNumber?: string;
    status?: string;
    currentVersion?: number;
    companyId?: number | undefined;
    companyName?: string;
    companyVAT?: string;
    originAddress?: string;
    destinationAddress?: string;
    cargoWeight?: number | undefined;
    cargoPackaging?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    cargoDescription?: string;
    expectedDeliveryDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    created?: Date;
    lastModified?: Date;
    versionCount?: number;
    deliveryConfirmationCount?: number;
    transportNoteCount?: number;
    hasReservations?: boolean;
    signatures?: DocumentSignatureDto[];

    constructor(data?: IDocumentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentUUID = _data["documentUUID"];
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.currentVersion = _data["currentVersion"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyVAT = _data["companyVAT"];
            this.originAddress = _data["originAddress"];
            this.destinationAddress = _data["destinationAddress"];
            this.cargoWeight = _data["cargoWeight"];
            this.cargoPackaging = _data["cargoPackaging"];
            this.senderName = _data["senderName"];
            this.receiverName = _data["receiverName"];
            this.cargoDescription = _data["cargoDescription"];
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.versionCount = _data["versionCount"];
            this.deliveryConfirmationCount = _data["deliveryConfirmationCount"];
            this.transportNoteCount = _data["transportNoteCount"];
            this.hasReservations = _data["hasReservations"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(DocumentSignatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentUUID"] = this.documentUUID;
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["currentVersion"] = this.currentVersion;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyVAT"] = this.companyVAT;
        data["originAddress"] = this.originAddress;
        data["destinationAddress"] = this.destinationAddress;
        data["cargoWeight"] = this.cargoWeight;
        data["cargoPackaging"] = this.cargoPackaging;
        data["senderName"] = this.senderName;
        data["receiverName"] = this.receiverName;
        data["cargoDescription"] = this.cargoDescription;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["versionCount"] = this.versionCount;
        data["deliveryConfirmationCount"] = this.deliveryConfirmationCount;
        data["transportNoteCount"] = this.transportNoteCount;
        data["hasReservations"] = this.hasReservations;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentDetailDto {
    id?: number;
    documentUUID?: string | undefined;
    documentNumber?: string;
    status?: string;
    currentVersion?: number;
    companyId?: number | undefined;
    companyName?: string;
    companyVAT?: string;
    originAddress?: string;
    destinationAddress?: string;
    cargoWeight?: number | undefined;
    cargoPackaging?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    cargoDescription?: string;
    expectedDeliveryDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    created?: Date;
    lastModified?: Date;
    versionCount?: number;
    deliveryConfirmationCount?: number;
    transportNoteCount?: number;
    hasReservations?: boolean;
    signatures?: DocumentSignatureDto[];
}

export class DocumentSignatureDto implements IDocumentSignatureDto {
    id?: number;
    role?: string;
    signedByName?: string;
    signedAt?: Date;
    signatureImagePath?: string;
    acceptingParty?: string;
    signatureLocation?: string | undefined;
    documentVersion?: number;
    isSuperseded?: boolean;

    constructor(data?: IDocumentSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.signedByName = _data["signedByName"];
            this.signedAt = _data["signedAt"] ? new Date(_data["signedAt"].toString()) : <any>undefined;
            this.signatureImagePath = _data["signatureImagePath"];
            this.acceptingParty = _data["acceptingParty"];
            this.signatureLocation = _data["signatureLocation"];
            this.documentVersion = _data["documentVersion"];
            this.isSuperseded = _data["isSuperseded"];
        }
    }

    static fromJS(data: any): DocumentSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["signedByName"] = this.signedByName;
        data["signedAt"] = this.signedAt ? this.signedAt.toISOString() : <any>undefined;
        data["signatureImagePath"] = this.signatureImagePath;
        data["acceptingParty"] = this.acceptingParty;
        data["signatureLocation"] = this.signatureLocation;
        data["documentVersion"] = this.documentVersion;
        data["isSuperseded"] = this.isSuperseded;
        return data;
    }
}

export interface IDocumentSignatureDto {
    id?: number;
    role?: string;
    signedByName?: string;
    signedAt?: Date;
    signatureImagePath?: string;
    acceptingParty?: string;
    signatureLocation?: string | undefined;
    documentVersion?: number;
    isSuperseded?: boolean;
}

export class PagedResultOfDocumentDto implements IPagedResultOfDocumentDto {
    items?: DocumentDto[];
    metadata?: PaginationMetadata;

    constructor(data?: IPagedResultOfDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? PaginationMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedResultOfDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedResultOfDocumentDto {
    items?: DocumentDto[];
    metadata?: PaginationMetadata;
}

export class DocumentDto implements IDocumentDto {
    id?: string;
    documentUUID?: string;
    documentNumber?: string;
    status?: string;
    originAddress?: string;
    destinationAddress?: string;
    expectedDeliveryDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    cargoDescription?: string;
    cargoWeight?: number | undefined;
    cargoPackaging?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    notes?: string | undefined;
    companyId?: number | undefined;
    clientId?: number;
    created?: Date;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentUUID = _data["documentUUID"];
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.originAddress = _data["originAddress"];
            this.destinationAddress = _data["destinationAddress"];
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
            this.cargoDescription = _data["cargoDescription"];
            this.cargoWeight = _data["cargoWeight"];
            this.cargoPackaging = _data["cargoPackaging"];
            this.senderName = _data["senderName"];
            this.receiverName = _data["receiverName"];
            this.notes = _data["notes"];
            this.companyId = _data["companyId"];
            this.clientId = _data["clientId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentUUID"] = this.documentUUID;
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["originAddress"] = this.originAddress;
        data["destinationAddress"] = this.destinationAddress;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
        data["cargoDescription"] = this.cargoDescription;
        data["cargoWeight"] = this.cargoWeight;
        data["cargoPackaging"] = this.cargoPackaging;
        data["senderName"] = this.senderName;
        data["receiverName"] = this.receiverName;
        data["notes"] = this.notes;
        data["companyId"] = this.companyId;
        data["clientId"] = this.clientId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentDto {
    id?: string;
    documentUUID?: string;
    documentNumber?: string;
    status?: string;
    originAddress?: string;
    destinationAddress?: string;
    expectedDeliveryDate?: Date | undefined;
    actualDeliveryDate?: Date | undefined;
    cargoDescription?: string;
    cargoWeight?: number | undefined;
    cargoPackaging?: string | undefined;
    senderName?: string | undefined;
    receiverName?: string | undefined;
    notes?: string | undefined;
    companyId?: number | undefined;
    clientId?: number;
    created?: Date;
}

export class RetrieveDocumentResponse implements IRetrieveDocumentResponse {
    xmlContent?: string;
    versionsCount?: number;

    constructor(data?: IRetrieveDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xmlContent = _data["xmlContent"];
            this.versionsCount = _data["versionsCount"];
        }
    }

    static fromJS(data: any): RetrieveDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xmlContent"] = this.xmlContent;
        data["versionsCount"] = this.versionsCount;
        return data;
    }
}

export interface IRetrieveDocumentResponse {
    xmlContent?: string;
    versionsCount?: number;
}

export class ShowDocumentResponse implements IShowDocumentResponse {
    htmlContent?: string;
    version?: number;

    constructor(data?: IShowDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.htmlContent = _data["htmlContent"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ShowDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShowDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["htmlContent"] = this.htmlContent;
        data["version"] = this.version;
        return data;
    }
}

export interface IShowDocumentResponse {
    htmlContent?: string;
    version?: number;
}

export class SignAndSubmitBlockchainRequestResponse implements ISignAndSubmitBlockchainRequestResponse {
    requestUUID?: string;
    status?: BlockchainApiStatus;
    message?: string;
    signature?: string;
    tokenQR?: string | undefined;
    token?: string | undefined;
    txHash?: string | undefined;

    constructor(data?: ISignAndSubmitBlockchainRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestUUID = _data["requestUUID"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.signature = _data["signature"];
            this.tokenQR = _data["tokenQR"];
            this.token = _data["token"];
            this.txHash = _data["txHash"];
        }
    }

    static fromJS(data: any): SignAndSubmitBlockchainRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignAndSubmitBlockchainRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUUID"] = this.requestUUID;
        data["status"] = this.status;
        data["message"] = this.message;
        data["signature"] = this.signature;
        data["tokenQR"] = this.tokenQR;
        data["token"] = this.token;
        data["txHash"] = this.txHash;
        return data;
    }
}

export interface ISignAndSubmitBlockchainRequestResponse {
    requestUUID?: string;
    status?: BlockchainApiStatus;
    message?: string;
    signature?: string;
    tokenQR?: string | undefined;
    token?: string | undefined;
    txHash?: string | undefined;
}

export enum BlockchainApiStatus {
    Pending = 0,
    Completed = 1,
    Failed = 2,
    Expired = 3,
}

export class SignAndSubmitBlockchainRequestCommand implements ISignAndSubmitBlockchainRequestCommand {
    requestUUID?: string;

    constructor(data?: ISignAndSubmitBlockchainRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestUUID = _data["requestUUID"];
        }
    }

    static fromJS(data: any): SignAndSubmitBlockchainRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignAndSubmitBlockchainRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUUID"] = this.requestUUID;
        return data;
    }
}

export interface ISignAndSubmitBlockchainRequestCommand {
    requestUUID?: string;
}

export class WalletSessionDto implements IWalletSessionDto {
    isUnlocked?: boolean;
    walletAddress?: string | undefined;
    expiresAt?: Date | undefined;
    sessionToken?: string | undefined;

    constructor(data?: IWalletSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUnlocked = _data["isUnlocked"];
            this.walletAddress = _data["walletAddress"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.sessionToken = _data["sessionToken"];
        }
    }

    static fromJS(data: any): WalletSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUnlocked"] = this.isUnlocked;
        data["walletAddress"] = this.walletAddress;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["sessionToken"] = this.sessionToken;
        return data;
    }
}

export interface IWalletSessionDto {
    isUnlocked?: boolean;
    walletAddress?: string | undefined;
    expiresAt?: Date | undefined;
    sessionToken?: string | undefined;
}

export class UnlockWalletResponse implements IUnlockWalletResponse {
    sessionToken?: string;
    walletAddress?: string;
    expiresAt?: Date;

    constructor(data?: IUnlockWalletResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.walletAddress = _data["walletAddress"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnlockWalletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockWalletResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["walletAddress"] = this.walletAddress;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUnlockWalletResponse {
    sessionToken?: string;
    walletAddress?: string;
    expiresAt?: Date;
}

export class ErrorDto implements IErrorDto {
    code?: string;
    description?: string;
    type?: ErrorType;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface IErrorDto {
    code?: string;
    description?: string;
    type?: ErrorType;
}

export enum ErrorType {
    Failure = 0,
    Validation = 1,
    Problem = 2,
    NotFound = 3,
    Conflict = 4,
}

export class UnlockWalletRequest implements IUnlockWalletRequest {
    password?: string;
    sessionDurationMinutes?: number | undefined;

    constructor(data?: IUnlockWalletRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.sessionDurationMinutes = _data["sessionDurationMinutes"];
        }
    }

    static fromJS(data: any): UnlockWalletRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockWalletRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["sessionDurationMinutes"] = this.sessionDurationMinutes;
        return data;
    }
}

export interface IUnlockWalletRequest {
    password?: string;
    sessionDurationMinutes?: number | undefined;
}

export class LockWalletResponse implements ILockWalletResponse {
    message?: string;

    constructor(data?: ILockWalletResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LockWalletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockWalletResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ILockWalletResponse {
    message?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}